import { CustomerVoucherSet } from '@kaa/api/customers';

export const getAvailableVouchers = (buyableVouchers: CustomerVoucherSet[]) =>
  buyableVouchers.reduce((acc, { quantity }) => acc + quantity, 0);
